import { Box, Container, Typography } from '@mui/material';

import type { ImageBlockContent } from '@/types/database';

export function ImageBlockView({ content }: { content: ImageBlockContent }) {
  if (!content.imageUrl) return null;

  return (
    <Box sx={{ py: 6 }}>
      <Container maxWidth="lg">
        <Box component="figure" sx={{ m: 0 }}>
          <Box
            component="img"
            src={content.imageUrl}
            alt={content.alt || ''}
            sx={{ width: '100%', borderRadius: 2, display: 'block', objectFit: content.objectFit ?? 'cover' }}
          />
          {content.caption ? (
            <Typography component="figcaption" variant="body2" color="text.secondary" sx={{ textAlign: "center", mt: 1 }}>
              {content.caption}
            </Typography>
          ) : null}
        </Box>
      </Container>
    </Box>
  );
}
